// extracted by mini-css-extract-plugin
export default {"page":"App_page__-tW5s","pageFullWidth":"App_pageFullWidth__mdT8o","body":"App_body__99xN-"};